import { render, staticRenderFns } from "./HomeworkSheetList.vue?vue&type=template&id=32797ccc&"
import script from "./HomeworkSheetList.vue?vue&type=script&lang=ts&"
export * from "./HomeworkSheetList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports